import { ACCESS_RIGHTS, CUSTOMER_RELATIONSHIP_TYPES } from "../../resources/enums";
import { sentenceCase } from "../../utilities/miscFunctions";

export default function RoleBadge({ role }: { role: ACCESS_RIGHTS | CUSTOMER_RELATIONSHIP_TYPES }) {
    const colors: Record<ACCESS_RIGHTS | CUSTOMER_RELATIONSHIP_TYPES, string> = {
        OWNER: "bg-purple-100 text-purple-700",
        MANAGER: "bg-green-100 text-green-700",
        ADMIN: "bg-blue-100 text-blue-700",
        AGENT: "bg-pink-100 text-pink-700",
        PRIMARY: "bg-violet-100 text-violet-700",
        MEMBER: "bg-orange-100 text-orange-700",
        DIRECTOR: "bg-yellow-100 text-yellow-700",
        SIGNATORY: "bg-wine-100 text-wine-700",
        NEXT_OF_KIN: "bg-red-100 text-red-700"
    };

    return (
        <span className={`px-2 py-1 text-xs rounded-full ${colors[role as ACCESS_RIGHTS]}`}>
            {sentenceCase(role)}
        </span>
    );
}